import { Injectable } from '@angular/core';

import { select, Store, Action } from '@ngrx/store';

import * as fromMessage from './message.reducer';
import * as MessageSelectors from './message.selectors';
import * as MessageActions from './message.actions';
import { MessageDTO } from '@care-portals/api-interfaces';

@Injectable()
export class MessageFacade {
  loading$ = this.store.pipe(select(MessageSelectors.getMessageLoading));
  sending$ = this.store.pipe(select(MessageSelectors.getMessageSending));
  allMessage$ = this.store.pipe(select(MessageSelectors.getAllMessage));
  messages$ = this.store.pipe(select(MessageSelectors.getAllMessage));

  constructor(private store: Store<fromMessage.MessagePartialState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  loadMessages(filters: any) {
    this.dispatch(MessageActions.loadMessages({ filters }));
  }

  sendMessage(message: MessageDTO, updateWatchList: boolean = true) {
    this.dispatch(MessageActions.sendMessage({ message, updateWatchList }));
  }
}
